import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./UsersDetailsDreamstreamTab.module.css";
import Card from "shared/Card";
import InfoItem from "shared/InfoItem";
import Button from "shared/Button";
import AddEmailModal from "../AddEmailModal";
import EditPinLevelModal from "../EditPinLevelModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

/**
 * Content in all details dreamstream page.
 */

export function UsersDetailsDreamstreamTab({
  dreamstreamInfo,
  dreamstreamAccess,
}) {
  const [addAltEmailModalOpen, setAddAltEmailModalOpen] = useState(false);
  const [editPinLevelModalOpen, setEditPinLevelModalOpen] = useState(false);
  const [isGenerateCode, setIsGenerateCode] = useState(false);

  // Generate temporary code
  function generateCode(length) {
    var result = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  function showGeneratedCode() {
    setIsGenerateCode(true);
  }

  return (
    <>
      <div className={styles.container}>
        <Card className={styles.cardContainer}>
          <div className={styles.cardHeader}>
            <h5 className={styles.title}>DREAMSTREAM INFO</h5>
            <div className={styles.hr} />
          </div>
          <div className={styles.infoContainer}>
            <div className={styles.infoDiv}>
              <InfoItem label="Status" description={dreamstreamInfo.status} />
            </div>
            <div className={styles.infoDiv}>
              <InfoItem
                label="Since"
                description={dreamstreamInfo.date + " ," + dreamstreamInfo.time}
              />
            </div>
            <div className={styles.infoDiv}>
              <InfoItem
                label="WWG Email"
                description={dreamstreamInfo.wwgEmail}
              />
            </div>
            {/* Needs to be Removed */}
            {/* <div className={styles.infoDiv}>
              <InfoItem
                label="Alternative Email"
                className={styles.altEmailBtn}
                children={
                  <Button
                    onClick={() => setAddAltEmailModalOpen(true)}
                    style={{
                      width: "60px",
                      height: "18px",
                      backgroundColor: "transparent",
                      fontSize: "8.5px",
                      color: "#243746",
                      border: "0.15em solid #243746",
                      borderRadius: "5px",
                    }}
                    size="tiny"
                  >
                    ADD EMAIL
                  </Button>
                }
                description=""
              />
            </div> */}
            <div className={styles.infoPinContainer}>
              <div className={styles.infoPinDiv}>
                <p className={styles.label}>Pin Level:</p>
              </div>
              <div className={styles.infoPinDiv}>
                <p className={styles.description}>{dreamstreamInfo.pinLevel}</p>
              </div>
              <div className={styles.infoPinDiv}>
                <button
                  type="button"
                  className={styles.editBtn}
                  onClick={() => {
                    setEditPinLevelModalOpen(true);
                  }}
                >
                  EDIT
                </button>
              </div>
            </div>
          </div>
        </Card>
        <Card className={styles.cardContainer}>
          <div className={styles.cardHeader}>
            <h5 className={styles.title}>DREAMSTREAM ACCESS</h5>
            <div className={styles.hr} />
          </div>

          <div className={styles.infoContainer}>
            <div className={styles.infoDiv}>
              <InfoItem label="DS ID:" description={dreamstreamAccess.dsId} />
            </div>
            <div className={styles.infoDiv}>
              <InfoItem
                label="Invited"
                description={dreamstreamAccess.invitedDateTime}
              />
            </div>

            <div className={styles.infoDiv}>
              <InfoItem
                label="Claimed:"
                className={styles.infoDiv}
                children={
                  <FontAwesomeIcon
                    icon={faCheck}
                    style={{
                      width: "15px",
                      paddingRight: "0px",
                    }}
                  />
                }
                description={dreamstreamAccess.claimedDateTime}
              />
            </div>
            <div className={styles.infoClaimedContainer}>
              <div className={styles.infoPinDiv}>
                <p className={styles.label}>Claimed Code:</p>
              </div>

              <div className={styles.infoClaimedDiv}>
                {!isGenerateCode ? (
                  <>
                    <button
                      type="button"
                      className={styles.codeBtn}
                      onClick={showGeneratedCode}
                    >
                      GENERATE CODE
                    </button>
                  </>
                ) : (
                  <>
                    <p className={styles.code}>{generateCode(8)}</p>
                    <p className={styles.codeText}>Expires in 5 days</p>
                  </>
                )}
              </div>
            </div>
          </div>
        </Card>

        <AddEmailModal
          isOpen={addAltEmailModalOpen}
          checked={false}
          onClose={() => setAddAltEmailModalOpen(false)}
          onClick={() => alert("Add Email clicked ")}
        />

        <EditPinLevelModal
          isOpen={editPinLevelModalOpen}
          foregoSync={false}
          noRefresh={false}
          onClose={() => setEditPinLevelModalOpen(false)}
          onClick={(e) => alert("Edit Pin level clicked " + e)}
        />
      </div>
    </>
  );
}

UsersDetailsDreamstreamTab.propTypes = {
  /**
   * Object with the dreamstream info.
   */
  dreamstreamInfo: PropTypes.shape({
    status: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
    wwgEmail: PropTypes.string,
    altEmail: PropTypes.string,
    pinLevel: PropTypes.string,
  }),

  /**
   * Object with the dreamstream access.
   */
  dreamstreamAccess: PropTypes.shape({
    dsId: PropTypes.string,
    invitedDateTime: PropTypes.string,
    claimedDateTime: PropTypes.string,
  }),
};
